import { useContext } from 'react'
import type { AuthContextValue } from './AuthContext'
import { AuthContext } from './AuthContext'

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext)
  if (!value) {
    throw new Error('useAuth should be wrapped within AuthContextProvider')
  }
  return value
}
